import { ILingoLiftImportGoogleroomClass } from '../model/types';

export const parseGoogleroomClassWithValue = (array: Array<ILingoLiftImportGoogleroomClass>) => {
  return array.map((item) => ({ ...item, value: false, elementary: false, studentStartQuiz: false }))
}
